import { useMemo } from "react";

import type { InvoiceSystemSettingsQueryQuery } from "@/lib/gql/__generated__/graphql";

import * as FormModel from "@/components/features/invoice-system-settings/model";
import type * as FormModelType from "@/components/features/invoice-system-settings/model/type";

import * as UseCase from "../use-update-invoice-system-settings";
import * as Converter from "./converter";

type Props = {
	data: InvoiceSystemSettingsQueryQuery;
};

export const useInitialized = ({ data }: Props) => {
	const initInputModel: FormModelType.InvoiceSystemSettingsFormModel["InputModel"] = useMemo(
		() => Converter.serverModelToInputModelConverter(data),
		[data],
	);

	const queryData: FormModelType.InvoiceSystemSettingsFormModel["QueryData"] = useMemo(
		() => data.invoiceSystemSettings,
		[data],
	);

	const { inputModel, viewModel, onSetViewModel, onResetViewModel } =
		FormModel.useInvoiceSystemSettingsFormModel(initInputModel);

	const { onUpdateInvoiceSystemSettings } = UseCase.useUpdateInvoiceSystemSettings({ inputModel, onResetViewModel });

	return {
		queryData,
		viewModel,
		onSetViewModel,

		onUpdateInvoiceSystemSettings,
	};
};
